import { connectedAccount } from '@/api/payment';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    loading: false,
    connectedAccount: {},
    createLinkLoading: false,
    retrieveBalanceLoading: false,
    balance: null,
    deauthorizeLoading: false,
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setCreateLinkLoading(state, isLoading) {
      state.createLinkLoading = isLoading;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    setRetrieveBalanceLoading(state, isLoading) {
      state.retrieveBalanceLoading = isLoading;
    },
    setDeauthorizeLoading(state, isLoading) {
      state.deauthorizeLoading = isLoading;
    },
    setConnectedAccount(state, payload) {
      state.connectedAccount = payload;
    },
  },
  actions: {
    isExist({ dispatch, rootGetters }) {
      try {
        const { stripe } = rootGetters['user/user'];
        return stripe && stripe.account;
      } catch (e) {
        return dispatch('errorOverlay/setMessage', e, { root: true });
      }
    },
    async create({ commit, dispatch, rootGetters }, createAccountParams) {
      try {
        commit('setLoading', true);
        const { stripe } = rootGetters['user/user'];
        const { data } = await connectedAccount.create(createAccountParams);
        await dispatch('user/editProfile', { stripe: { ...stripe, account: data.id } }, { root: true });
        window.open(data.url, '_self');
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
    async createLink({ commit, dispatch }, id) {
      try {
        commit('setCreateLinkLoading', true);
        const { data } = await connectedAccount.link.create(id);
        window.open(data.url, '_self');
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setCreateLinkLoading', false);
      }
    },
    async retrieveBalance({ commit, dispatch }, stripeAccount) {
      try {
        commit('setRetrieveBalanceLoading', true);
        const { data } = await connectedAccount.balance.retrieve(stripeAccount);
        commit('setBalance', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setRetrieveBalanceLoading', false);
      }
    },
    async deauthorize({ commit, dispatch }) {
      try {
        commit('setDeauthorizeLoading', true);
        await connectedAccount.deauthorize();
        commit('setConnectedAccount', {});
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setDeauthorizeLoading', false);
      }
    },
    async retrieve({ commit, dispatch }, id) {
      try {
        const { data } = await connectedAccount.retrieve(id);
        commit('setConnectedAccount', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      }
    },
  },
  getters: {
    loading: state => state.loading,
    createLinkLoading: state => state.createLinkLoading,
    balance: state => state.balance || {},
    retrieveBalanceLoading: state => state.retrieveBalanceLoading,
    deauthorizeLoading: state => state.deauthorizeLoading,
    connectedAccount: state => state.connectedAccount || {},
  },
};
